/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type { CommuteOptionsResult, CommuteRequest } from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useCommuteGetCommuteTimeHook = () => {
  const commuteGetCommuteTime = useCustomInstance<CommuteOptionsResult>();

  return useCallback(
    (commuteRequest: CommuteRequest) => {
      return commuteGetCommuteTime({
        url: `/api/Commute/GetCommuteTime`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: commuteRequest,
      });
    },
    [commuteGetCommuteTime]
  );
};

export const useCommuteGetCommuteTimeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommuteGetCommuteTimeHook>>>,
    TError,
    { data: CommuteRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCommuteGetCommuteTimeHook>>>,
  TError,
  { data: CommuteRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const commuteGetCommuteTime = useCommuteGetCommuteTimeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCommuteGetCommuteTimeHook>>>,
    { data: CommuteRequest }
  > = (props) => {
    const { data } = props ?? {};

    return commuteGetCommuteTime(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommuteGetCommuteTimeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCommuteGetCommuteTimeHook>>>
>;
export type CommuteGetCommuteTimeMutationBody = CommuteRequest;
export type CommuteGetCommuteTimeMutationError = unknown;

export const useCommuteGetCommuteTime = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommuteGetCommuteTimeHook>>>,
    TError,
    { data: CommuteRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCommuteGetCommuteTimeHook>>>,
  TError,
  { data: CommuteRequest },
  TContext
> => {
  const mutationOptions = useCommuteGetCommuteTimeMutationOptions(options);

  return useMutation(mutationOptions);
};
